"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pixel2ToJSON = exports.Pixel2FromJSONTyped = exports.Pixel2FromJSON = exports.instanceOfPixel2 = void 0;
var runtime_1 = require("../runtime");
var Event2_1 = require("./Event2");
var HistoricalEvent2_1 = require("./HistoricalEvent2");
/**
 * Check if a given object implements the Pixel2 interface.
 */
function instanceOfPixel2(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPixel2 = instanceOfPixel2;
function Pixel2FromJSON(json) {
    return Pixel2FromJSONTyped(json, false);
}
exports.Pixel2FromJSON = Pixel2FromJSON;
function Pixel2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'integrationId': !(0, runtime_1.exists)(json, 'integration_id') ? undefined : json['integration_id'],
        'domain': !(0, runtime_1.exists)(json, 'domain') ? undefined : json['domain'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'events': !(0, runtime_1.exists)(json, 'events') ? undefined : (json['events'].map(Event2_1.Event2FromJSON)),
        'historicalEvents': !(0, runtime_1.exists)(json, 'historical_events') ? undefined : (json['historical_events'].map(HistoricalEvent2_1.HistoricalEvent2FromJSON)),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
    };
}
exports.Pixel2FromJSONTyped = Pixel2FromJSONTyped;
function Pixel2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'name': value.name,
        'dataset_id': value.datasetId,
    };
}
exports.Pixel2ToJSON = Pixel2ToJSON;
